import { useLayoutEffect, useRef } from 'react';

export function useFocusRef(isFocused: boolean) {
  const inputRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (inputRef.current && isFocused) {
      inputRef.current.focus();
    }
  }, [isFocused]);
  return inputRef;
}
